"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsAppFloatingButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var fa_1 = require("react-icons/fa");
var globalFuncionts_1 = require("@utils/globalFuncionts");
var styles_1 = require("./styles");
function WhatsAppFloatingButton() {
    return ((0, jsx_runtime_1.jsx)(styles_1.Button, __assign({ type: "button", "aria-label": "Contactar por WhatsApp", onClick: function () { return (0, globalFuncionts_1.onOpenWhatsAppContactGbc)(); } }, { children: (0, jsx_runtime_1.jsx)(fa_1.FaWhatsapp, {}) })));
}
exports.WhatsAppFloatingButton = WhatsAppFloatingButton;
